// Abre em nova aba um PDF servido por rota autenticada (o JWT vai no header do axios,
// então não dá para usar window.open direto na URL da API)
export async function openAuthenticatedPdf(url) {
  // Abre a aba antes do await para o navegador não bloquear como popup
  const win = window.open("", "_blank");

  try {
    const response = await window.axios.get(url, { responseType: "blob" });
    const blobUrl = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/pdf" })
    );

    if (win) {
      win.location.href = blobUrl;
    } else {
      window.open(blobUrl, "_blank");
    }
  } catch (error) {
    if (win) win.close();
    throw error;
  }
}
